export * from './acesso.component';
